<template>
    <div>
        <v-flex class="d-flex mb-8 justify-space-between">
            <!-- <div class="col-5">
                <v-text-field v-model="users.search" label="Search" append-icon="mdi-magnify" single-line hide-details>
                </v-text-field>
            </div> -->
            <v-spacer></v-spacer>
            <div>
                <v-dialog v-if="canAddNew" v-model="openAddPopup" max-width="1200px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="white--text" color="primary my-2" v-bind="attrs" v-on="on">
                            <v-icon left class="mr-4">
                                mdi-account-plus
                            </v-icon>
                            {{ $t('addNewLabel') }}
                        </v-btn>
                    </template>
                    <v-card class="pa-10">
                        <v-card-title>
                            <span class="headline">{{ $t('addNewUserLabel') }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="newUser.FirstName" class="pa-0" hide-details="auto"
                                            outlined :label="$t('nameFormLabel')">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="newUser.LastName" class="pa-0" hide-details="auto"
                                            outlined :label="$t('surnameFormLabel')">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="newUser.Email" class="pa-0" hide-details="auto" outlined
                                            :label="$t('emailFormLabel')">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="newUser.PersonalNumber" class="pa-0" hide-details="auto"
                                            outlined :label="$t('personalNumberFormLabel')">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-center align-center">
                            <v-btn min-width="150" class="green white--text px-10" @click="saveUser">{{$t('saveDataLabel')}}</v-btn>

                            <v-btn min-width="150" class="primary white--text px-2" color=""
                                @click="openAddPopup = false">{{$t('cancelLabel')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>

        </v-flex>
        <v-data-table :headers="users.headers" :items="users.values" :loading="loading"
            :loading-text="$t('tableLoadingLabel')" hide-default-footer>
            <template #item.active="{item}">
                {{item.active ? $t('trueLabel') : $t('falseLabel') }}
            </template>
            <template #item.locked="{item}">
                {{item.locked ? $t('trueLabel') : $t('falseLabel') }}
            </template>
            <template #item.actions="{ item }">
                <v-dialog v-if="canLock" v-model="lockUserDialog" max-width="800px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn min-width="100px" v-if="item.locked"
                            @click="() => {selectedUser = item; isLock = false; isUnlock = true;}" class="white--text"
                            small color="green my-2" v-bind="attrs" v-on="on">
                            <v-icon left class="mr-4">
                                mdi-account-cog
                            </v-icon>
                            {{$t('unlockLabel')}}
                        </v-btn>
                        <v-btn v-else min-width="100px" class="white--text"
                            @click="() => {selectedUser = item; isLock = true; isUnlock = false;}" small
                            color="red my-2" v-bind="attrs" v-on="on">
                            <v-icon left class="mr-4">
                                mdi-account-cog
                            </v-icon>
                            {{$t('lockLabel')}}
                        </v-btn>
                    </template>
                    <v-card class="pa-10">
                        <div>
                            <v-card-title class="justify-center">
                                <span class="headline">{{isLock ? $t('lockUserLabel') : $t('unlockUserLabel')}}</span>
                            </v-card-title>

                            <v-card-text v-if="isLock">
                                <v-container>
                                    <v-row>
                                        <p class="body-1 text-center">
                                            {{ $t("lockUserText") }}
                                        </p>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-text v-else>
                                <v-container>
                                    <v-row>
                                        <p class="body-1 text-center">
                                            {{ $t("unlockUserText") }}
                                        </p>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions class="d-flex justify-center align-center">
                                <v-btn v-if="isLock" width="150" class="white--text px-10" color="red"
                                    @click="lockUser()"> {{$t('lockUserLabel')}}
                                </v-btn>

                                <v-btn v-else width="150" class="white--text px-10" color="green" @click="unlockUser()">
                                    {{ $t('unlockUserLabel') }}
                                </v-btn>

                                <v-btn width="150" class="primary px-2" color="" @click="() => lockUserDialog = false">
                                    {{$t('cancelLabel')}}</v-btn>
                            </v-card-actions>
                        </div>

                    </v-card>
                </v-dialog>
                <v-btn min-width="100px" class="my-1 ml-4 primary--text" small outlined
                    :to="{ name: 'AffiliateUserDetails' , params: { companyId: parentCompanyId, affiliateCompanyId: companyId, affiliateUserId: item.id} }">
                    View User
                </v-btn>
            </template>
            <template v-slot:no-data>
                {{$t('noDataAvailable')}}
            </template>
            <template v-slot:no-results>
                {{$t('noDataAvailable')}}
            </template>
        </v-data-table>
        <v-pagination v-model="page" :length="pageCount" @input="getUsers()"></v-pagination>

    </div>
</template>
<script>
    import UserTypes from '../auth/userTypes'

    export default {
        name: 'AffiliatePartnershipSalesTable.vue',
        data() {
            return {
                parentCompanyId:'',
                page: 1,
                pageCount: 1,
                amount: 5,
                openAddPopup: false,
                canAddNew: false,
                canLock: false,
                selectedUser: {},
                isLock: false,
                isUnlock: false,
                lockUserDialog: false,
                newUser: {
                    FirstName: "",
                    LastName: "",
                    Email: "",
                    PersonalNumber: ""
                },
                loading: false,
                users: {
                    search: '',
                    headers: [
                        {
                            text: this.$t('usersNameLabel'),
                            value: 'userFullName',
                        },
                        {
                            text: this.$t('usersPersonalNoLabel'),
                            value: 'personalNo',
                        },
                        {
                            text: this.$t('usersEmailLabel'),
                            value: 'email',
                        },
                        {
                            text: this.$t('usersStatusLabel'),
                            value: 'active',
                        },
                        {
                            text: this.$t('usersLockedLabel'),
                            value: 'locked',
                        },
                        {
                            text: '',
                            sortable: false,
                            value: 'actions',
                            align: 'end'
                        },
                    ],
                    values: [],
                },
                snackbar: {
                  show: true,
                  message: "",
                }
            }
        },
        props: {
            companyId: Number,
            showUserPath: String,
        },
        methods: {
            getUsers() {
                this.loading = true
                let companyId = this.$props.companyId;
                this.axios.get('/api/user/getbycompanyandtype', {
                    params: {
                        companyId: this.$props.companyId,
                        userType: UserTypes.AffiliatePartnershipSales,
                        amount: this.amount,
                        page: this.page
                    }
                }).then(response => {
                    console.log(response.data)
                    this.loading = false
                    this.users.values = response.data.users;
                    this.pageCount= response.data.pages;
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                    this.loading = false
                });
            },

            lockUser() {
                var data = {
                    Id: this.selectedUser.id,
                }
                this.axios.post('api/user/lockuser', data).then(response => {
                    let index = this.users.values.map(item => {
                        return item.id
                    }).indexOf(this.selectedUser.id)
                    this.users.values.splice(index, 1, response.data)
                    this.selectedUser = {};
                    this.isLock = false;
                    this.isUnlock = false;
                    this.lockUserDialog = false;
                    this.snackbar.message = this.$t("userLockedLabel")
                    this.$EventBus.$emit("snackbar", this.snackbar);
                }).catch(error => {
                    this.loading = false
                    this.snackbar.message = error.message
                    this.$EventBus.$emit("snackbar", this.snackbar);
                });
            },

            unlockUser() {
                var data = {
                    Id: this.selectedUser.id,
                }
                this.axios.post('api/user/unlockuser', data).then(response => {
                    let index = this.users.values.map(item => {
                        return item.id
                    }).indexOf(this.selectedUser.id)

                    this.users.values.splice(index, 1, response.data)
                    this.selectedUser = {};
                    this.isLock = false;
                    this.isUnlock = false;
                    this.lockUserDialog = false;
                    this.snackbar.message = this.$t("userUnlockedLabel")
                    this.$EventBus.$emit("snackbar", this.snackbar);
                }).catch(error => {
                    this.loading = false
                    this.snackbar.message = error.message
                    this.$EventBus.$emit("snackbar", this.snackbar);
                });
            },
            checkAddAndLockAvaliablity() {
                if (this.$store.state.user.userType == UserTypes.WertheimAdministrator || this.$store.state.user
                    .userType == UserTypes.SalesPartnershipAdmin)
                    this.canLock = true;
                this.canAddNew = true;
            },
            saveUser() {
                const userObject = {
                    FirstName: this.newUser.FirstName,
                    LastName: this.newUser.LastName,
                    Email: this.newUser.Email,
                    UserType: UserTypes.AffiliatePartnershipSales,
                    PersonalNumber: this.newUser.PersonalNumber,
                    CompanyId: this.$props.companyId
                }

                this.axios.post('api/user/create', userObject).then(response => {
                    this.users.values = response.data;
                    this.openAddPopup = false;
                    this.snackbar.message = 'User created!'
                    this.$EventBus.$emit("snackbar", this.snackbar);
                }).catch(error => {
                    this.loading = false
                    this.snackbar.message = error.message
                    this.$EventBus.$emit("snackbar", this.snackbar);
                });

            },
            getParentCompany(){
                this.parentCompanyId = parseInt(this.$route.params.companyId);
            }
        },
        mounted() {
            this.getUsers();
            this.checkAddAndLockAvaliablity();
            this.getParentCompany();
        },
    }
</script>
<style scoped>

</style>